import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

import type { DealerID, DealerLocationID } from "models";

export type ExactAccount = {
  ID: string;
  Code: string;
  Name: string;
  City: string;
  Country: string;
  Postcode: string;
  Language: string;
  VATNumber: string;
  AddressLine1: string;
  ChamberOfCommerce: string;
  Contact?: {
    Email: string;
    Initials: string;
    LastName: string;
  };
};

type RetrieveExactAccountPayload = {
  dealer_id?: DealerID;
  dealer_location_id?: DealerLocationID;
};

export const useRetrieveExactAccountMutation = () =>
  useTypedMutation<RetrieveExactAccountPayload, ExactAccount>({
    mutationFn: async payload => (await ApiInstance.post("/accounts/retrieve", payload, ENV.exactBaseURL)).data,
    onSuccess: () => null
  });
